import React, { Component } from 'react';
import ViewALLRiskTableView from './TableView/index';
import { connect } from 'react-redux';
import withAuth from '../../../components/Services/WithAuth';
import { riskFactorList, downloadEditRiskFactorTemplate, uploadEditRiskFactorTemplate } from './action';
import { Col, Card, CardBody, Row, Button } from 'reactstrap';
import fileSaver from 'file-saver';
import { toast } from 'react-toastify';
import { Preloading } from '../../../components/UI/Preloader/action';
// import { stat } from 'fs';

class RiskFactorListComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allRiskFactorsList: [],
            ShowError: false,
            loading: true,
            errorList: []
        };
    }

    componentDidMount() {
        this.props.riskFactorList();
    }

    componentDidUpdate(prevProps) {
        const { downloadRiskFactorEditTemplate, downloadRiskFactorEditTemplateFailure, uploadRiskFactorEditTemplate, uploadRiskFactorEditTemplateFailure } = this.props;

        if (downloadRiskFactorEditTemplate !== prevProps.downloadRiskFactorEditTemplate) {
            this.props.preloading(false);
            let blob = new Blob([downloadRiskFactorEditTemplate], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            fileSaver.saveAs(blob, `Risk_Factor_Edit_Template.xlsx`);
        }
        if (downloadRiskFactorEditTemplateFailure !== prevProps.downloadRiskFactorEditTemplateFailure) {
            this.props.preloading(false);
            toast.error(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{downloadRiskFactorEditTemplateFailure.data.message}
                </div>
            );
        }
        if (uploadRiskFactorEditTemplate !== prevProps.uploadRiskFactorEditTemplate) {
            this.props.preloading(false);
            toast.success(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{uploadRiskFactorEditTemplate.message}
                </div>
            );
            document.getElementById('file').value = null
        }
        if (uploadRiskFactorEditTemplateFailure !== prevProps.uploadRiskFactorEditTemplateFailure) {
            this.props.preloading(false);
            if (Array.isArray(uploadRiskFactorEditTemplateFailure.data.message)) {
                this.setState({
                    errorList: uploadRiskFactorEditTemplateFailure.data.message
                })
            } else {
                toast.error(
                    <div style={{ wordBreak: 'break-all' }}>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{uploadRiskFactorEditTemplateFailure.data.message}
                    </div>
                );
            }
            document.getElementById('file').value = null
        }
        if (this.props.riskFactorListData !== prevProps.riskFactorListData) {
            this.setState({
                allRiskFactorsList: this.props.riskFactorListData.data,
                ShowError: false,
                loading: false
            })
        }
        else if (this.props.riskFactorListDataError !== prevProps.riskFactorListDataError) {
            this.setState({
                allRiskFactorsList: [],
                ShowError: true,
                loading: false
            })
        }
    }
    downloadEditTemplate = () => {
        this.props.preloading(true);
        this.props.downloadEditRiskFactorTemplate();
    }
    uploadEditTemplate = (event) => {
        this.props.preloading(true);
        this.props.uploadEditRiskFactorTemplate(event.target.files[0])
    }

    clearErrors = () => {
        this.setState({
            errorList: []
        })
    }

    render() {
        return (
            <Col>
                <Row>
                    <Col sm='20' className="d-flex justify-content-between align-items-center mb-3"><h4>Risk Factor List</h4></Col>
                    <Col sm='4' className="d-flex justify-content-between align-items-center mb-3"><Button outline color='primary' onClick={this.downloadEditTemplate}><i className="fa fa-download"></i></Button>
                        <div color="primary" className="btn btn-primary ml-3 position-relative" title="Upload New Risk Factor">
                            {/* <div> */}
                            <input onChange={this.uploadEditTemplate} type="file" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                            <i className="fa fa-upload"></i>
                        </div>
                    </Col>
                </Row>
                {
                    (this.state.errorList.length > 0) ?
                        <Card className='table-card'>
                            <CardBody>
                                <Card className='table-card text-danger'>
                                    <ul>
                                        {this.state.errorList.map((error, index) => {
                                            return <li key={error}>{index + 1}- &nbsp;{error}</li>
                                        })}
                                    </ul>
                                </Card>
                            </CardBody>
                            <span onClick={this.clearErrors} style={{ marginLeft: '1.6%', cursor: 'pointer' }}>Clear All</span>
                        </Card> : null
                }
                <Card>
                    <CardBody>
                        <div className="overridding-risk-table">
                            <ViewALLRiskTableView {...this.props}
                                data={this.state.allRiskFactorsList}
                                loading={this.state.loading} />
                        </div>
                    </CardBody>
                </Card>

            </Col>
        );
    }
    // }
}

const mapStateToProps = (state) => ({
    riskFactorListData: state.riskFactorList.riskFactorListSuccessData,
    riskFactorListDataError: state.riskFactorList.riskFactorListFailure,
    uploadRiskFactorEditTemplate: state.riskFactorList.uploadRiskFactorEditTemplate,
    uploadRiskFactorEditTemplateFailure: state.riskFactorList.uploadRiskFactorEditTemplateFailure,
    downloadRiskFactorEditTemplate: state.riskFactorList.downloadRiskFactorEditTemplate,
    downloadRiskFactorEditTemplateFailure: state.riskFactorList.downloadRiskFactorEditTemplateFailure
});

const mapDispatchToProps = (dispatch) => ({
    riskFactorList: () => { dispatch(riskFactorList()) },
    uploadEditRiskFactorTemplate: (data) => { dispatch(uploadEditRiskFactorTemplate(data)) },
    downloadEditRiskFactorTemplate: () => { dispatch(downloadEditRiskFactorTemplate()) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(RiskFactorListComponent));

